import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { BrandingService, translateSiteTitle } from '@next/core-lib/branding';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteRootState, SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { getPwaFaviconUrl } from './pwa-branding';

@Injectable()
export class PwaBrandingService extends BrandingService {
  private readonly titleDocument = inject(DOCUMENT);
  private readonly locale = inject(LocaleService);
  private readonly pageTitle = inject(Store<SiteRootState>).selectSignal(
    SiteSelectors.selectPageTitle,
  );

  override getFaviconUrl(): string {
    return getPwaFaviconUrl(this.getTenantName());
  }

  getTitle(): string {
    return this.titleDocument.title;
  }

  setTitle(_title: string): void {
    const name = translateSiteTitle(this.getTenantName(), (key) => this.locale.translate(key));
    this.titleDocument.title = [name, this.pageTitle()].filter(Boolean).join(' - ');
  }
}
